/** Merge public participant rows with caller's full private row (owner-only fields). */
export function mergeTripParticipantsForOwner(publicRows, ownRow) {
  const participants = (publicRows || []).map((p) =>
    ownRow && p.user_id === ownRow.user_id ? { ...p, ...ownRow } : p,
  );

  if (ownRow && !participants.some((p) => p.id === ownRow.id)) {
    participants.push(ownRow);
  }

  return participants;
}
